import React from 'react';

import { BaseLabel, RowContainer, InputSmall, Label } from '../../../../styles/styleUtils';
import CampoMonetario from '../../components/CampoMonetario';

function formatDateToInputValue(date) {
  const localDate = new Date(date);
  localDate.setMinutes(localDate.getMinutes() - localDate.getTimezoneOffset()); // Corrige fuso
  return localDate.toISOString().split('T')[0];
}

function DocumentoDetalhes({ formData, onInputChange }) {
  return (
    <div>
      <RowContainer>
        <BaseLabel htmlFor="cpf">Valor Documento</BaseLabel>
        <CampoMonetario disabled={formData.idVenda} name={'valor'} valor={formData.valor} onChange={onInputChange} />
        <spam />
        <spam />
        <spam />
        <spam />
        <spam />
        <spam />
        <Label htmlFor="vencimento">Data Vencimento</Label>
        <InputSmall
          type="date"
          id="vencimento"
          name="vencimento"
          value={formatDateToInputValue(formData.vencimento)}
          onChange={onInputChange}
          disabled={formData.idVenda}
        />
      </RowContainer>
    </div>
  );
}

export default DocumentoDetalhes;
